import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { waLink, track } from "../../lib/site";

export default function FloatingCTAs() {
  const { settings } = useSite();
  return (
    <>
      <a href={waLink(settings)} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn" onClick={() => track("whatsapp_click")}
        aria-label="Chat with us on WhatsApp"
        className="fixed bottom-24 md:bottom-8 right-5 z-40 w-14 h-14 rounded-full bg-[#1FA855] text-white flex items-center justify-center shadow-xl transition-transform duration-200 hover:scale-105">
        <MessageCircle size={24} />
      </a>
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-black/10 px-4 py-3">
        <Link to="/apply" data-testid="mobile-sticky-apply-btn" onClick={() => track("start_application")}
          className="btn-primary w-full !py-3">Apply Now — Free Eligibility Check</Link>
      </div>
    </>
  );
}
